import { FeatureFlag } from "@web-app/types";
import http from "@web-app/utils/http";

export const getFeatureflags = async () => {
  return http
    .get<FeatureFlag[]>("/featureFlags")
    .then((response) => response.data);
};
